import NodeTypes from "./node-types";

let makeMnemonicItem = (m, parent) => {
  let title = m.Title;
  let mnemonic = m.Mnemonic;

  if (title && title.toLowerCase() !== mnemonic.toLowerCase()) {
    title = `${mnemonic} - ${title}`;
  }

  return {
    id: m.ID,
    title: title || mnemonic,
    nodeType: NodeTypes.mnemonic,
    hasChildren: false,
    expanded: false,
    loading: false,
    children: [],
    parent: parent,
    original: m,
    hidden: false
  }
};

let makeTypeItem = (t, parent) => {
  let title = t.Title;

  if (!title) {
    title = t.Name;

    let lastIndexOf = title.lastIndexOf('.');

    if (lastIndexOf > 0) {
      title = title.substring(lastIndexOf + 1);
    }
  }

  let item = {
    id: t.Name,
    title: title,
    nodeType: NodeTypes.entityType,
    hasChildren: true,
    expanded: false,
    loading: false,
    parent: parent,
    original: t,
    hidden: false
  };

  item.icon = t.Icon || 'far fa-tenge fa-fw';

  item.children = t.Mnemonics
    ? t.Mnemonics.map(m => { return makeMnemonicItem(m, item); })
    : [];

  return item;
};

let makeAssymblyItem = (a) => {
  let title = a.Title || a.Name;

  let item = {
    id: a.Name,
    title: title.replace('Visary.', ''),
    nodeType: NodeTypes.assembly,
    hasChildren: true,
    expanded: false,
    loading: false,
    original: a,
    hidden: false,
    icon: "fal fa-atom fa-fw"
  };

  item.children = a.EntityTypes
    ? a.EntityTypes.map(t => { return makeTypeItem(t, item); })
    : [];

  return item;
}

export default {
  makeMnemonicItem,
  makeTypeItem,
  makeAssymblyItem,
}
